import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const subs = new Set();

export function refreshSettings() {
  return api.get("/public/settings").then((r) => {
    cache = r.data;
    subs.forEach((fn) => fn(r.data));
    return r.data;
  }).catch(() => {});
}

export function useSettings() {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    subs.add(setSettings);
    if (cache) setSettings(cache);
    else refreshSettings();
    return () => subs.delete(setSettings);
  }, []);
  return { settings };
}
